// extracted by css-extract-rspack-plugin
export default {"box":"Prefectures__box--gqs0D"};